import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import Image from 'react-retina-image';

import styles, { hideOnDesktop } from './Header.module.scss';
import { BRAND } from '../../constants/brand';
import { Button, Link, Nav } from '..';
import { BOOKING_LINK } from '../../constants/booking';

interface HeaderProps {
  className?: string;
  location: any;
  navOpen: boolean;
  setNavOpen: any;
}

const Header: FunctionComponent<HeaderProps> = ({
  className,
  location,
  navOpen,
  setNavOpen,
}) => {
  const headerClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-header`,
    className,
    {
      [styles.header]: true,
      [styles.headerNavOpen]: navOpen,
    },
  );

  const MENU_ID = 'primary-nav';

  const containerClass = classNames({
    [styles.containerNavOpen]: navOpen,
    [styles.container]: true,
  });

  const menuCloseButtonClass = classNames({
    [styles.link]: true,
    [styles.menuButton]: true,
    [styles.hide]: !navOpen,
  });

  const menuOpenButtonClass = classNames({
    [styles.link]: true,
    [styles.menuButton]: true,
  });

  const logoButtonClass = classNames({
    [styles.link]: true,
    [styles.logoButton]: true,
  });
  const bookingButtonClass = classNames({
    [styles.link]: true,
    [styles.bookingButton]: true,
    [styles.hideOnMobile]: true,
  });
  const contactButtonClass = classNames({
    [styles.link]: true,
    [styles.contactButton]: true,
  });

  return (
    <div className={containerClass}>
      <header className={headerClass}>
        {navOpen && (
          <Button
            className={menuCloseButtonClass}
            noStyles
            aria-controls={MENU_ID}
            aria-expanded={navOpen}
            onClick={() => setNavOpen(false)}
            containerClassName={styles.hideOnDesktop}
          >
            <Image
              aria-hidden
              forceOriginalDimensions={false}
              src="/images/menuButtonClose.png"
              alt="Close menu"
            />
          </Button>
        )}
        {!navOpen && (
          <Button
            className={menuOpenButtonClass}
            containerClassName={styles.hideOnDesktop}
            noStyles
            aria-controls={MENU_ID}
            aria-expanded={navOpen}
            onClick={() => setNavOpen(true)}
          >
            <Image
              forceOriginalDimensions={false}
              src="/images/menuButtonOpen.png"
              alt="Open menu"
            />
          </Button>
        )}
        <Link
          className={logoButtonClass}
          noStyles
          to="/"
          title="Home"
          onClick={() => setNavOpen(false)}
        >
          <Image
            forceOriginalDimensions={false}
            src="/images/icon.png"
            alt="Crystal Canine"
          />
        </Link>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link
            className={bookingButtonClass}
            noStyles
            to={BOOKING_LINK}
            external
          >
            Booking
          </Link>
          <Link
            className={contactButtonClass}
            noStyles
            to="/contact"
            onClick={() => setNavOpen(false)}
          >
            <Image
              forceOriginalDimensions={false}
              src="/images/contact.png"
              alt="Contact"
              className={styles.hideOnDesktop}
            />
            <span className={styles.hideOnMobile}>Contact</span>
          </Link>
        </div>
      </header>
      <Nav location={location} navOpen={navOpen} setNavOpen={setNavOpen}>
        <Button
          className={menuCloseButtonClass}
          containerClassName={hideOnDesktop}
          noStyles
          aria-controls={MENU_ID}
          aria-expanded={navOpen}
          onClick={() => setNavOpen(false)}
        >
          <Image
            aria-hidden
            forceOriginalDimensions={false}
            src="/images/menuButtonClose.png"
            alt="Close menu"
          />
        </Button>
      </Nav>
    </div>
  );
};

export default Header;
